import {LOGIN, LOGOUT} from "../constants/userActionTypes";

export const login = user => {
    return {
        type: LOGIN,
        payload: user
    }
};

export const logout = user => {
    return {
        type: LOGOUT,
    }
};


// WEBPACK FOOTER //
// ./src/actions/userAction.js